import Flickity from './wwdevFlickity';
require('flickity-fade');
require('flickity-as-nav-for');

class FlickityCarousel {
	constructor(config) {
		this.config = Object.assign({
			scope: '.flickity-carousel',
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each(function (it, el) {
			let settings = this.defaultSettings();

			Object.keys($(el).data()).forEach(function (key) {
				Object.assign(settings, {[key]: $(el).data(key)});
			});

			new Flickity(el, settings);
		}.bind(this));
	}

	// Je kunt hier de standaard waardes aanpassen.
	defaultSettings() {
		return {
			cellAlign: 'left',
			contain: true,
			groupCells: true,
			arrowShape: 'M 73.023868,0.89086168 A 7.4015143,7.4015143 0 0 1 77.649815,4.162755 7.4015143,7.4015143 0 0 1 75.332022,14.373568 c 0,0 -10.191085,6.435229 -20.262609,14.644012 -5.035763,4.10439 -10.007229,8.656616 -13.453793,12.740628 -3.446565,4.084009 -4.813876,7.788524 -4.813876,8.33634 0,0.547816 1.367352,4.2574 4.813876,8.341159 3.446522,4.08376 8.41805,8.636548 13.453793,12.740628 10.071487,8.208162 20.262609,14.639194 20.262609,14.639194 a 7.4015143,7.4015143 0 0 1 2.317793,10.210813 7.4015143,7.4015143 0 0 1 -10.210814,2.312975 c 0,0 -10.801019,-6.788631 -21.722674,-15.689669 C 40.2555,78.199127 34.72723,73.225763 30.301324,67.981541 25.875419,62.73732 21.998715,57.312147 21.998715,50.094548 c 0,-7.217599 3.876749,-12.642561 8.302609,-17.886993 C 34.727188,26.963124 40.25552,21.990276 45.716327,17.539451 56.637946,8.6377994 67.439001,1.8449632 67.439001,1.8449632 a 7.4015143,7.4015143 0 0 1 5.584867,-0.95410152 z'
		}
	}
}

export default FlickityCarousel;